const ContactData = {
    en: {
        // Hero Section
        badge: 'CONTACT US',
        hero: {
            title: "Your Local Contractors",
            titleHighlight: 'in SWFL.',
            subtitle: "When you need to find a contractor for Cape Coral — contact us for Dock Construction, Boat Lift Installation, Repair, and Maintenance services.",
            subtitleHighlight: "We'll get back to you right away!",
        },

        contactMethods: [
            {
                id: 'call',
                label: 'Call Us',
                value: '+1 (239) 542-1004',
                detail: 'Mon–Fri 10:00 AM – 4:00 PM',
            },
            {
                id: 'email',
                label: 'Email Us',
                value: '[email protected]',
                detail: 'We reply promptly',
            },
        ],

        location: {
            title: 'SERVICE AREA',
            name: 'TROPICAL MARINE CONSTRUCTION',
            address: 'Cape Coral, FL 33904\nLee County & Collier County\nSouthwest Florida (SWFL)',
        },

        features: [
            { id: 'response',  label: 'Fast Response',    detail: 'We respond to all inquiries promptly and schedule consultations quickly.' },
            { id: 'licensed',  label: 'Licensed & Insured', detail: 'Florida Certified Building Contractor License #CBC1260600.' },
            { id: 'estimate',  label: 'Free Estimates',   detail: 'We provide written estimates for all dock and boat lift projects.' },
        ],

        topics: [
            { id: 'BoatLiftRepairs',       title: 'Boat Lift Repairs' },
            { id: 'BoatLiftReplacement',   title: 'Boat Lift Replacement' },
            { id: 'BoatLiftMaintenance',   title: 'Boat Lift Maintenance' },
            { id: 'BoatLiftAdjustments',   title: 'Boat Lift Platform Adjustments' },
            { id: 'BoatLiftAccessories',   title: 'Boat Lift Accessories' },
            { id: 'BoatLiftCanopy',        title: 'Boat Lift Canopy' },
            { id: 'BunkBoards',            title: 'New Bunk Boards' },
            { id: 'DockRepairs',           title: 'New Dock or Dock Repairs' },
            { id: 'TikiHut',               title: 'Tiki Hut' },
            { id: 'other',                 title: 'Other' }
        ],
        otherLabel: 'Other Request',

        consent: {
            marketing: 'I agree to receive communications about my inquiry',
            terms:     'I agree to the Terms of Service',
            termsLink: '/terms',
        },

        mainForm: {
            title: 'Get a Free Estimate',
            subtitle: "Fill out the form below and we'll get back to you as soon as possible.",
            placeholders: {
                name:          'Your Name',
                phone:         'Phone Number',
                email:         'Email Address',
                website:       '',
                message:       'Tell us about your project...',
                selectService: 'What are you interested in?'
            },
            submitLabel:   'Send Message',
            sendingLabel:  'Sending...',
            leadSource:    'Tropical Marine Construction Website',
            successTitle:  'Message Received!',
            successSubtitle: 'We will get back to you promptly to discuss your project.',
        },

        lightweightForm: {
            title: 'Get a Free Estimate',
            placeholders: {
                name:  'Your Name',
                phone: 'Phone Number',
                email: 'Email Address'
            },
            submitLabel:  'Request Estimate',
            sendingLabel: '...',
            leadSource:   'Tropical Marine Construction Sidebar',
            errorMsg:     'Please provide a phone number or email.'
        }
    },

    he: {
        badge: 'CONTACT US',
        hero: {
            title: "Your Local Contractors",
            titleHighlight: 'in SWFL.',
            subtitle: "When you need to find a contractor for Cape Coral — contact us for Dock Construction, Boat Lift Installation, Repair, and Maintenance services.",
            subtitleHighlight: "We'll get back to you right away!",
        },

        contactMethods: [
            {
                id: 'call',
                label: 'Call Us',
                value: '+1 (239) 542-1004',
                detail: 'Mon–Fri 10:00 AM – 4:00 PM',
            },
            {
                id: 'email',
                label: 'Email Us',
                value: '[email protected]',
                detail: 'We reply promptly',
            },
        ],

        location: {
            title: 'SERVICE AREA',
            name: 'TROPICAL MARINE CONSTRUCTION',
            address: 'Cape Coral, FL 33904\nLee County & Collier County\nSouthwest Florida (SWFL)',
        },

        features: [
            { id: 'response',  label: 'Fast Response',      detail: 'We respond to all inquiries promptly and schedule consultations quickly.' },
            { id: 'licensed',  label: 'Licensed & Insured',  detail: 'Florida Certified Building Contractor License #CBC1260600.' },
            { id: 'estimate',  label: 'Free Estimates',      detail: 'We provide written estimates for all dock and boat lift projects.' },
        ],

        topics: [
            { id: 'BoatLiftRepairs',       title: 'Boat Lift Repairs' },
            { id: 'BoatLiftReplacement',   title: 'Boat Lift Replacement' },
            { id: 'BoatLiftMaintenance',   title: 'Boat Lift Maintenance' },
            { id: 'BoatLiftAdjustments',   title: 'Boat Lift Platform Adjustments' },
            { id: 'BoatLiftAccessories',   title: 'Boat Lift Accessories' },
            { id: 'BoatLiftCanopy',        title: 'Boat Lift Canopy' },
            { id: 'BunkBoards',            title: 'New Bunk Boards' },
            { id: 'DockRepairs',           title: 'New Dock or Dock Repairs' },
            { id: 'TikiHut',               title: 'Tiki Hut' },
            { id: 'other',                 title: 'Other' }
        ],
        otherLabel: 'Other Request',

        consent: {
            marketing: 'I agree to receive communications about my inquiry',
            terms:     'I agree to the Terms of Service',
            termsLink: '/terms',
        },

        mainForm: {
            title: 'Get a Free Estimate',
            subtitle: "Fill out the form below and we'll get back to you as soon as possible.",
            placeholders: {
                name:          'Your Name',
                phone:         'Phone Number',
                email:         'Email Address',
                website:       '',
                message:       'Tell us about your project...',
                selectService: 'What are you interested in?'
            },
            submitLabel:   'Send Message',
            sendingLabel:  'Sending...',
            leadSource:    'Tropical Marine Construction Website',
            successTitle:  'Message Received!',
            successSubtitle: 'We will get back to you promptly to discuss your project.',
        },

        lightweightForm: {
            title: 'Get a Free Estimate',
            placeholders: {
                name:  'Your Name',
                phone: 'Phone Number',
                email: 'Email Address'
            },
            submitLabel:  'Request Estimate',
            sendingLabel: '...',
            leadSource:   'Tropical Marine Construction Sidebar',
            errorMsg:     'Please provide a phone number or email.'
        }
    }
};

export function getContactData(language) {
    return ContactData[language] || ContactData.en;
}

export default ContactData;
